import React from "react";
import styled from "styled-components";
import { Main } from "../../styles/";
import { Heading } from "../";

const StyledContacts = styled(Main)`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  padding-top: 7rem;
`;

const NumberLink = styled.a`
  text-decoration: none;
  color: #2f9dd9;
  font-size: 32px;
  font-weight: 700;
`;

const Email = styled.p`
  color: #2f9dd9;
  font-size: 16px;
  font-weight: 700;
  text-decoration: underline;
`;

const SocialBox = styled.ul`
  margin-top: 5rem;
  display: flex;
  gap: 1rem;
  list-style-type: none;
  align-items: center;
`;

const SocialLink = styled.a`
  display: block;
  color: ${({ color }) => color || "#ffffff"};
  text-decoration: none;
  font-weight: 700px;
  padding: 1rem;
  border: 2px solid ${({ color }) => color || "#ffffff"};
  border-radius: 10px;
  text-transform: uppercase;
`;

export const Contacts = () => {
  return (
    <StyledContacts>
      <Heading
        color="#c4c4c4"
        as="h1"
        tagStyle="h5"
        style={{ textTransform: "uppercase" }}
      >
        Frontend Developer – Денис Мирошников
      </Heading>
      <NumberLink href="https://t.me/dexxp">t.me/@dexxp</NumberLink>
      <Email>denmir999@gmail.com</Email>
      <SocialBox>
        <li>
          <SocialLink
            color="#E71515"
            href="https://belgorod.hh.ru/resume/ae0fbaf7ff090e72a60039ed1f6c4b72367359"
          >
            hh
          </SocialLink>
        </li>
        <li>
          <SocialLink color="#2787f5" href="https://vk.com/dexxp">
            vk
          </SocialLink>
        </li>
        <li>
          <SocialLink color="" href="https://github.com/dexxp">
            gh
          </SocialLink>
        </li>
      </SocialBox>
    </StyledContacts>
  );
};
